export default {
  title: 'App',
  fields: {
    id: 'ID',
    name: 'Nome',
    app_bundle_identifier: 'App Bundle ID',
    released: 'Rilasciato',
    franchise: 'Marchio',
    app_icon: 'Icona app',
    status: 'Stato',
    play_store_link: 'Link Play Store',
    apple_store_link: 'Link Apple Store',
    dynamic_link: 'Link dinamico - Codici QR',
  },
  filters: {
    name: 'Nome',
    released: 'Rilasciato',
  },
  columns: {
    backlog: '📋 Backlog',
    ready_to_build: '🛠️ Pronto per la build',
    in_work: '🔧 In lavorazione',
    in_review: '📝 In revisione',
    rejected: '❌ Rifiutato',
    released: '✅ Rilasciato',
    deactivated: '🛑 Disattivato',
  },
  card: {
    overdue: 'In ritardo · {{time}}',
    copied: 'Copiato negli appunti',
    released_tag: {
      both: '✅ Rilasciato',
      ios: 'iOS rilasciato',
      android: 'Android rilasciato',
    },
    tags: {
      has_tech_issue: 'Problema tecnico',
    },
  },
  status_modal: {
    title: 'Aggiorna stato di rilascio',
    status_label: 'Stato',
    note_label: 'Nota (opzionale)',
    note_placeholder: 'Aggiungi una nota opzionale per questa modifica di stato',
    tech_issue_checkbox: "C'è un problema tecnico",
    save: 'Salva',
    cancel: 'Annulla',
  },
  released: {
    yes: 'Sì',
    no: 'No',
  },
  configured_status: {
    true: 'Sì',
    false: 'No',
  },
  delete_confirmation: {
    title: 'Elimina app mobile',
    message: 'Sei sicuro di voler eliminare questa app mobile?',
    buttons: {
      confirm: 'Conferma',
      cancel: 'Annulla',
    },
  },
};
